<template>
  <div id="signup">
    <v-container>
      <v-layout class="logo-container mb-3 mt-3" row justify-center>
        <v-flex xs4>
          <img src="../../assets/logo.png" alt="RE" height="75" width="auto">
        </v-flex>
      </v-layout>
      <v-layout column>
        <v-flex>
          <v-form v-model="valid" ref="form" >
            <v-text-field
              label="Name"
              v-model="name"
              :rules="nameRules"
              @keyup.enter="submit"
              required
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="email"
              :rules="emailRules"
              @keyup.enter="submit"
              required
            ></v-text-field>
            <v-text-field
              label="Phone"
              v-model="phone"
              :rules="phoneRules"
              @keyup.enter="submit"
              required
            ></v-text-field>
            <v-text-field
              id="upassword"
              label="Password"
              v-model="upassword"
              ref="upassword"
              :rules="passRules"
              :append-icon="visiblePass ? 'visibility' : 'visibility_off'"
              @click:append="() => (visiblePass = !visiblePass)"
              :type="visiblePass ? 'password' : 'text'"
              @keyup.enter="submit"
              required
            ></v-text-field>
            <v-text-field
              label="Re-Password"
              v-model="reUpassword"
              :rules="reUpassRules"
              :append-icon="visibleRePass ? 'visibility' : 'visibility_off'"
              @click:append="() => (visibleRePass = !visibleRePass)"
              :type="visibleRePass ? 'password' : 'text'"
              @keyup.enter="submit"
              required
            ></v-text-field>
            <v-btn
              @click="submit"
              :disabled="!valid"
              :loading="loading"
              style="float: right; margin-top: 25px"
            >
              submit
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import services from '@/services/services'

  export default {
    data () {
      return {
        valid: true,
        name: '',
        visiblePass: true,
        visibleRePass: true,
        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length > 1) || 'Name must be longer than one letter'
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        phone: null,
        phoneRules: [
          v => !!v || 'Phone is required',
          // eslint-disable-next-line
          v => /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(v) || 'Phone must be valid'
        ],
        upassword: '',
        passRules: [
          v => !!v || 'Password is required',
          v => (v.length > 6) || 'Must be longer than 6 characters',
          v => /[A-Z]/.test(v) || 'Must contain a capital letter',
          v => /.*[0-9].*/.test(v) || 'Must contain a number'
        ],
        reUpassword: '',
        reUpassRules: [
          v => !!v || 'Re-entry is required',
          v => (v === this.upassword) || 'Passwords do not match'
        ]
      }
    },
    methods: {
      async submit () {
        if (this.$refs.form.validate()) {
          const response = await services.createUser({
            email: this.email,
            password: this.upassword,
            phone: this.phone,
            name: this.name
          })

          if (response.status == 201) {
            this.$store.dispatch('setUser', response.data)
              .then(() => {
                this.$router.push({ name: 'home' })
              })
              .catch(error => {
                this.showError(error)
              })
          }
        }
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isLoading
      }
    }
  }
</script>

<style>
  #signup {
    width: 100%;
  }
</style>
